/* global fetch, self */
'use strict'
const uuid = require('uuid')
const isString_ = require('lodash/isString')
const flow_ = require('lodash/flow')
const merge_ = require('lodash/merge')
const isError_ = require('lodash/isError')
const result = require('folktale/result')

/*
export type Tracer = {
  levels: {},
  trace: ({}) => ({}) => void
}
*/

const levels = {
  INFO: 'info',
  WARN: 'warn',
  ERROR: 'error'
}

const tryOrGetUnknown = callback => result.try(callback).getOrElse('unknown')

function _sendRequest(baseUrl, data) {
  const options = {
    method: 'POST',
    body: JSON.stringify(data),
    mode: 'cors',
    credentials: 'include',
    headers: new self.Headers({
      'Content-Type': 'application/json'
    })
  }

  return fetch(`${baseUrl}/logstash/events`, options)
}

function shouldReport() {
  return tryOrGetUnknown(() => self['wix-window'].rendering.env) === 'backend'
}

function _reportKibana(params, baseUrl) {
  if (!shouldReport()) {
    return
  }

  const transformedParams = _transform(params)

  _sendRequest(baseUrl, transformedParams).catch(() => {})
}

function _stringifyMessage(params) {
  return !isString_(params.message)
    ? merge_({}, params, { message: JSON.stringify(params.message) })
    : params
}

function _extractErrorInfo(params) {
  if (!isError_(params.message)) {
    return params
  }

  const error = params.message
  const newParams = {}
  if (error.stack) {
    newParams.stackTrace = error.stack
    newParams.message = error.message
  } else {
    newParams.message = error.toString()
  }

  return merge_({}, params, newParams)
}

function _transform(params) {
  return flow_(_extractErrorInfo, _stringifyMessage)(params)
}

function _getDefaultParams() {
  return {
    source: 'wix-code-client',
    level: levels.INFO,
    userActionId: uuid.v4(),
    params: {
      url: tryOrGetUnknown(() => self['wix-location'].url),
      env: tryOrGetUnknown(() => self['wix-window'].rendering.env)
    }
  }
}

function traceStart(params) {
  const baseUrl =
    self.elementorySupport.baseUrl.replace(
      'wix-code-public-dispatcher/siteview',
      ''
    ) + 'cloud-monitoring-hub/v1'
  const date = new Date()
  const start = date.getTime()
  const extendedParams = merge_({}, _getDefaultParams(), params, {
    timestamp: date.toJSON(),
    actionPosition: 'start'
  })
  _reportKibana(extendedParams, baseUrl)
  return function(endParams) {
    const traceEnd = () => {
      const endDate = new Date()
      const current = endDate.getTime()
      const duration = (current - start) / 1000
      endParams = merge_({}, extendedParams, endParams, {
        timestamp: endDate.toJSON(),
        duration,
        actionPosition: 'end'
      })
      _reportKibana(endParams, baseUrl)
    }

    result.try(traceEnd).getOrElse(undefined)
  }
}

function tryTraceStart(...args) {
  return result.try(() => traceStart(...args)).getOrElse(() => {})
}

module.exports = {
  levels,
  trace: tryTraceStart
}



// WEBPACK FOOTER //
// ./tracing/tracer.js